import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../theme/utils.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const IconDot = (_a) => {
  var props = __objRest(_a, []);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { "data-baseweb": "icon", "aria-hidden": "true", viewBox: "0 0 4 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "icon-dot", children: [jsx("title", { id: "icon-dot", children: "Icon dot" }), jsx("circle", { cx: "2", cy: "2", r: "2", fill: "#406367" })] }));
};
styled(IconDot, getSvgStyles);

export { IconDot };
